export var createReadElementContent = function (readVariableSizeInteger) {
    return function (dataView, offset, type, channelCount) {
        if (channelCount === void 0) { channelCount = 2; }
        var lengthAndValue = readVariableSizeInteger(dataView, offset);
        if (lengthAndValue === null) {
            return lengthAndValue;
        }
        var length = lengthAndValue.length, value = lengthAndValue.value;
        if (type === 'master') {
            return { content: null, length: length };
        }
        if (offset + length + value > dataView.byteLength) {
            return null;
        }
        if (type === 'binary') {
            var numberOfSamples_1 = (value / Float32Array.BYTES_PER_ELEMENT - 1) / channelCount;
            var content = Array.from({ length: channelCount }, function () { return new Float32Array(numberOfSamples_1); });
            for (var i = 0; i < numberOfSamples_1; i += 1) {
                var elementOffset = i * channelCount + 1;
                for (var j = 0; j < channelCount; j += 1) {
                    content[j][i] = dataView.getFloat32(offset + length + (elementOffset + j) * Float32Array.BYTES_PER_ELEMENT, true);
                }
            }
            return { content: content, length: length + value };
        }
        return { content: null, length: length + value };
    };
};
//# sourceMappingURL=read-element-content.js.map
